module.exports = __webpack_public_path__ + "img/arrow-down-short.ec7049d0.svg";